import platform from '@propertypal/shared/src/utils/platform';
import React, { FunctionComponent } from 'react';
import Button from '../buttons/Button';
import { LinkText } from '../typography';
import { Container, FooterContent } from './ServerError.style';

const ServerError: FunctionComponent = () => {
  return (
    <Container>
      <h1>
        Our server is taking a break… <br />
        you should take one too.
      </h1>

      <h3>Don’t worry, our developers are on it and we’ll be back in no time!</h3>

      <Button onClick={() => window.location.reload()}>Refresh</Button>

      <FooterContent>
        <p>
          Please check again in a little while or contact{' '}
          <LinkText href={`mailto:${platform.helpEmail}`}>{platform.helpEmail}</LinkText>.
        </p>
      </FooterContent>
    </Container>
  );
};

export default ServerError;
